import { getScoreboardStores, renderScoreboard } from 'app/render'
import { Root } from 'app/containers/Root'


if (typeof window !== 'undefined') {
    // tslint:disable-next-line:no-var-requires
    require('./polyfills')
}

export const renderApp = (document: Document) => {
    const stores = getScoreboardStores(document)
    stores.forEach((value) => renderScoreboard(Root, value))

}
renderApp(document)